import { resolveMediaUrl, getEffectiveBackendUrl, joinUrl } from '@/config/app'

/** Extrai nome do arquivo em URLs backlog-files ou filename solto (uuid.jpg). */
function backlogFileNameFromMediaUrl (resolved) {
  if (!resolved) return null
  const s = String(resolved).trim()
  if (!s || s.startsWith('data:') || s.startsWith('blob:')) return null

  const fromPath = s.match(/\/backlog-files\/([^/?#]+)/i)
  if (fromPath?.[1]) return fromPath[1]

  const fromApi = s.match(/\/files\/([^/?#]+)/i)
  if (fromApi?.[1] && /backlog-api/i.test(s)) return fromApi[1]

  if (!s.includes('/') && /^[a-f0-9-]+\.(jpg|jpeg|png|gif|webp)$/i.test(s)) {
    return s
  }

  return null
}

/** Monta URL via API (CORS + mesma origem do SPA em produção). */
function backlogFileApiUrl (fileName) {
  const api = getEffectiveBackendUrl()
  if (!api || !fileName) return null

  const path = joinUrl(api.replace(/\/+$/, ''), `files/${fileName}`)
  if (typeof window !== 'undefined' && path.startsWith('/')) {
    return `${window.location.origin}${path}`
  }
  return path
}

/** URL da logo/foto do workspace para HTML público e PDF. */
export function resolveOrcamentoMediaUrl (raw) {
  if (!raw) return ''
  const resolved = resolveMediaUrl(raw) || String(raw).trim()
  if (!resolved) return ''
  if (resolved.startsWith('data:') || resolved.startsWith('blob:')) return resolved

  const fileName = backlogFileNameFromMediaUrl(resolved)
  if (fileName) {
    const apiUrl = backlogFileApiUrl(fileName)
    if (apiUrl) return apiUrl
  }

  return resolved
}

/** Reescreve src das imagens no HTML do orçamento para URLs absolutas válidas. */
export function patchOrcamentoHtmlMedia (html, fotoWorkspaceFallback = '') {
  if (!html || typeof html !== 'string') return html || ''

  let out = html.replace(
    /(<img\b[^>]*\ssrc=)(["'])([^"']+)\2/gi,
    (match, prefix, quote, src) => {
      const resolved = resolveOrcamentoMediaUrl(src.trim()) || src.trim()
      return `${prefix}${quote}${resolved}${quote}`
    }
  )

  if (fotoWorkspaceFallback) {
    const logoUrl = resolveOrcamentoMediaUrl(fotoWorkspaceFallback)
    if (logoUrl) {
      out = out.replace(
        /(<img\b[^>]*class=["'][^"']*logo-img[^"']*["'][^>]*\ssrc=)(["'])([^"']*)\2/gi,
        `$1$2${logoUrl}$2`
      )
    }
  }

  return out
}

export function publicOrcamentoUrl (token) {
  const origin = typeof window !== 'undefined' ? window.location.origin : ''
  return `${origin}/orcamento/${token}`
}

export function whatsappShareUrl (text) {
  return `https://wa.me/?text=${encodeURIComponent(text)}`
}

export function formatOrcamentoMoney (value) {
  const n = Number(value) || 0
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

export function emptyOrcamentoForm () {
  return {
    titulo: '',
    informacoesGerais: '',
    condicoesPagamento: '',
    validadeDias: 15,
    leadId: null,
    itens: [{ nome: '', descricao: '', valor: 0, ordem: 0 }]
  }
}
